import 'fetch-polyfill';
import API from '../../APIconfig';

import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from '../async/asyncActions';

import { NET_BANKING_OPTIONS } from './DropDownConstants';

export const getNetBankingOptions = (csrfRequestIdentifier) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart("", false, 'netbank'));
      const reqObject = {
        method: API.payment.netBankingOptions.method,
        credentials : 'include',
        mode : 'cors',
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
        }),
      };

      const banks = await fetch(API.payment.netBankingOptions.url, reqObject).then(response=>response.json());
      
      dispatch({
        type: NET_BANKING_OPTIONS,
        payload: banks,
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
};